import { RoutePrefix } from './classes/RoutePrefix';

export const rootPrefix = new RoutePrefix('');

export const infoPath = rootPrefix.path('.info');

export const localizedPrefix = new RoutePrefix('/:lang');

export const homePath = localizedPrefix.rootPath();

export const movementPath = rootPrefix.path('movement');

export const wydPath = rootPrefix.path('wyd');

// Post a listing

export const createOrgPath = rootPrefix.path('organizations/create', ['step']);

export const postAListingPath = rootPrefix.path('post-a-listing', [
  'listingType',
]);

// Invoice

export const viewInvoicePath = rootPrefix.path('invoices/:invoiceId');

export const viewDonationReceiptPath = rootPrefix.path(
  'donation-receipts/:invoiceId',
);

// Email

export const emailRateRecommendedCandidatePath = rootPrefix.path(
  'email/rate-recommended-candidate/:applicantId/:rating', // rating: good | bad
);

// Unsubscribe

export const unsubscribePreferencePath = rootPrefix.path(
  'unsubscribe/:preferenceName/:userId/:timestamp',
);

export const unsubscribeOrgPreferencePath = rootPrefix.path(
  'unsubscribe/org/:orgId/:preferenceName/:userId/:timestamp',
);

// Facebook data deletion

export const facebookDataDeletionPath = rootPrefix.path(
  'facebook-data-deletion/:deletionCode',
);

// User-uploaded files

export const userUploadsRoutePrefix = rootPrefix.subprefix('uploads');

// Other

export const invalidOrExpiredLinkPath = rootPrefix.path(
  'invalid-or-expired-link',
);
